import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { BULK_SKIP_REASON_LABELS } from "../../../constants/users";
import { BulkSkippedUser } from "../../../store/slices/UsersV3Slice";

// The server omits the email for users the caller may not see (OUT_OF_SCOPE)
// or that no longer exist (NOT_FOUND).
const getSkippedUserLabel = (user: BulkSkippedUser) =>
  user.email ?? (user.reason === "OUT_OF_SCOPE" ? "Hidden user" : "Unknown user");

interface SkippedUsersListProps {
  title: string;
  skipped: BulkSkippedUser[];
  // Groups the action's audit rows; quoted to support when following up.
  batchId: string | null;
}

// Users the server left untouched in a bulk move/deactivate, with the reason.
const SkippedUsersList = ({ title, skipped, batchId }: SkippedUsersListProps) => (
  <div className="rounded-lg border border-amber-200 bg-amber-50 p-4">
    <div className="flex items-center gap-2 text-sm font-semibold text-amber-800">
      <ExclamationTriangleIcon className="h-5 w-5" aria-hidden="true" />
      {title}
    </div>
    <ul className="mt-3 flex max-h-48 flex-col gap-2 overflow-y-auto text-sm">
      {skipped.map((user) => (
        <li key={user.userId} className="flex flex-wrap justify-between gap-x-4">
          <span className="font-medium text-texthead">{getSkippedUserLabel(user)}</span>
          <span className="text-amber-800">{BULK_SKIP_REASON_LABELS[user.reason] ?? user.reason}</span>
        </li>
      ))}
    </ul>
    {batchId && <p className="mt-3 text-xs text-textColor">Reference: {batchId}</p>}
  </div>
);

export default SkippedUsersList;
